import { defineComponent } from "vue";
import styles from "./Content.module.less";
import Header from "../Header/Header";
import Tags from "../Tags/Tags";
export default defineComponent({
  props: {
    isCollapsed: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:isCollapsed'],
  setup(props: any, { emit, slots }) {
    return () => (
      <div class={styles.content}>
        <Header isCollapsed={props.isCollapsed} onUpdate:isCollapsed={(e) => { emit("update:isCollapsed", e) }} />
        <Tags />
        <div class={styles.main}>
          {slots?.default?.()}
        </div>
      </div>
    )
  }
})